/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Division_FinanceInputs */

const en_mk_mock_division_finance = /** @type {(inputs: Mk_Mock_Division_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance & Ops`)
};

const id_mk_mock_division_finance = /** @type {(inputs: Mk_Mock_Division_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance & Ops`)
};

/**
* | output |
* | --- |
* | "Finance & Ops" |
*
* @param {Mk_Mock_Division_FinanceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_division_finance = /** @type {((inputs?: Mk_Mock_Division_FinanceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Division_FinanceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_division_finance(inputs)
	return en_mk_mock_division_finance(inputs)
});